<template>
  <panel title="店铺销售情况" :infoContents="infoContents" class="mgb10">
    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="shopName" title="店铺"></vxe-table-column>
      <vxe-table-colgroup title="今天">
        <vxe-table-column
          field="bargainQty"
          :title="$t('report.orderQty')"
        ></vxe-table-column>
        <vxe-table-column field="productQty" title="产品量"></vxe-table-column>
        <vxe-table-column field="salesAmount" title="销售额">
          <template v-slot="{ row }">
            {{ row.symbol }}{{ row.salesAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="bargainAmount" title="成交额">
          <template v-slot="{ row }">
            {{ row.symbol }}{{ row.bargainAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="payAmount" title="实收额">
          <template v-slot="{ row }">
            {{ row.symbol }}{{ row.payAmount }}
            <span v-if="row.ignorePayAmount != null" class="font10">
              ({{ row.symbol }}{{ row.ignorePayAmount }})
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="differAmount" title="差额">
          <template v-slot="{ row }">
            <router-link
              :to="{
                name: 'portalsShopSalesCountDetail',
                query: { data: 'today', shopId: row.shopId },
              }"
            >
              {{ row.symbol }}{{ row.differAmount }}
            </router-link>
          </template>
        </vxe-table-column>
      </vxe-table-colgroup>
      <vxe-table-colgroup title="本月">
        <vxe-table-column
          field="monthBargainQty"
          :title="$t('report.orderQty')"
        ></vxe-table-column>
        <vxe-table-column
          field="monthProductQty"
          title="产品量"
        ></vxe-table-column>
        <vxe-table-column field="monthSalesAmount" title="销售额">
          <template v-slot="{ row }">
            {{ row.symbol }}{{ row.monthSalesAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="monthBargainAmount" title="成交额">
          <template v-slot="{ row }">
            {{ row.symbol }}{{ row.monthBargainAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="monthPayAmount" title="实收额">
          <template v-slot="{ row }">
            {{ row.symbol }}{{ row.monthPayAmount }}
            <span v-if="row.monthIgnorePayAmount != null" class="font10">
              ({{ row.symbol }}{{ row.monthIgnorePayAmount }})
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="monthDifferAmount" title="差额">
          <template v-slot="{ row }">
            <router-link
              :to="{
                name: 'portalsShopSalesCountDetail',
                query: { data: 'month', shopId: row.shopId },
              }"
            >
              {{ row.symbol }}{{ row.monthDifferAmount }}
            </router-link>
          </template>
        </vxe-table-column>
      </vxe-table-colgroup>
    </vxe-table>
  </panel>
</template>

<script>
import Bargain from "@/api/bargain.js";
export default {
  data() {
    return {
      loading: false,
      records: [],
      infoContents: [
        "订单量：以订单项的创建日期统计 订单条数(不包含取消退货的订单项)",
        "产品量：以订单项的创建日期统计 订单项数量 和(不包含取消退货的订单项)",
        "销售额：以订单项的创建日期统计 售价*数量 和(不包含取消退货的订单项)",
        "成交额：以订单项的创建日期统计 成交单价*数量 和(不包含取消退货的订单项，包含附加费)",
        "实收额：以收款创建日期统计收款合计",
        "差额：成交额 - 实收额",
      ],
    };
  },
  created() {
    const self = this;
    self.loading = true;
    Bargain.shopSalesCount().then(function (res) {
      if (res.status === 200) {
        self.records = res.data;
      } else {
        self.sysError();
      }
      self.loading = false;
    });
  },
};
</script>